var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6557 18.8814C12.653 23.4087 6.71878 22.3952 3.5587 19.7029C0.899137 17.4369 -0.055344 14.1976 0.00609402 11.9667C-0.157083 8.20036 2.9532 1.87654 10.1206 2.00182C13.4641 2.19985 15.3373 3.58892 16.6768 4.98868L14.4417 7.31204C13.387 6.40733 12.2097 5.41226 10.1526 5.27976C5.16354 5.41632 3.24199 9.37103 3.2389 11.8028C3.35047 15.1615 4.74616 16.5531 6.4717 17.7358C9.41563 19.2092 12.2584 18.7945 14.4404 16.5362L16.6557 18.8814Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1486 10.0796V13.8809L18.4549 13.8577L18.4775 16.8245L24 11.9571L18.4775 7.18234L18.4323 10.0796H10.1486Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOff);
export default __webpack_public_path__ + "static/media/LogOff.21c1a2a030aee70638e75312df8250f9.svg";
export { ForwardRef as ReactComponent };